import { has } from 'lodash';
import { schema } from 'normalizr';
import { SCHEMA_TYPE_FLOW_NODES } from '../constants/schemaTypes';

const flowNodeSchema = new schema.Entity(
  SCHEMA_TYPE_FLOW_NODES,
  {},
  {
    processStrategy: (value, parent, key) => {
      const { id, data_source_id, data_set_id } = value;
      const type = data_source_id ? 'SOURCE' : data_set_id ? 'DATA_SET' : 'DATA_SINK';
      const depth = has(parent, 'parent_node_id')
        ? parent.parent_node_id
          ? parent.depth + 1
          : 1
        : 0;
      let dataSetType = null;

      if (type === 'DATA_SET') {
        if (depth === 0) {
          dataSetType = 'shared';
        } else if (parent.type === 'SOURCE' && depth === 1) {
          dataSetType = 'source';
        } else {
          dataSetType = 'derived';
        }
      }

      return {
        ...value,
        type,
        depth,
        dataSetType,

        // preserving nodeKey to avoid changing the code that's dependent on it
        // but setting it to flow node ID
        nodeKey: id,
      };
    },
  },
);

flowNodeSchema.define({
  children: [flowNodeSchema],
  linked_flows: [flowNodeSchema],
  triggering_flows: [flowNodeSchema],
  triggered_flows: [flowNodeSchema],
});

export default flowNodeSchema;
